/**
 * Guest-realm source for the Terminal extension. Terminal is host-rendered
 * (TerminalExtSidebar.js + TerminalExtView.js) and talks to the Rust
 * ssh_term_* / terminal_* commands directly via invoke — SSH credentials are
 * resolved inside Rust from the vault and never enter the guest sandbox.
 * This entry script is a no-op kept only to satisfy the registration
 * contract.
 */
export const terminalEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
